import styled from 'styled-components';

export { PopupContent, HeaderRow, HeaderTitle, CloseButton, ErrorMessage } from '../shared.styled';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem 1.4rem 1.4rem;
`;
